(function () {
  'use strict';

  angular
    .module('operationsSummaryReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('operationsSummaryReport', {
        url: '/operations-summary-report',
        views : {
			'operationsSummaryReportView' : {
				templateUrl : 'operations-summary-report/views/operations-summary-report.tpl.html',
				controller : 'OperationsSummaryReportCtrl',
				controllerAs : 'operationsSummaryReport'
			}
		},
      });
  }
}());
